export const ADM = 1;
export const GFE = 2;
export const GFO = 3;
export const GFU = 4;
export const GPPE = 5; //GPO
export const GPP = 6; //GP
export const FRENTISTA = 7;
export const GPPEM = 8;
export const ATENDIMENTO_CALLCENT = 62;
export const SERVICE_DESK = 64;
export const MANUTENÇÃO_UNIDATA = 65;
export const CONSULTA_OPERACAO = 66;
export const GFE_CONSULTA = 67;
export const GFO_CONSULTA = 68;
export const GFU_CONSULTA = 69;
export const GPPE_CONSULTA = 70;
export const GPP_CONSULTA = 71;
export const FRENTISTA_CONSULTA = 72;
export const GESTAO_VEICULOS = 73;
export const CONSULTA_ABASTECIMEN = 75;
export const GESTOR_UNIDATA_COMERCIAL = 76;
export const GESTOR_UNIDATA_FINANCEIR = 77;
